module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAhElEQVRYhe3QOw2AQBCE4TkHSEEAZjBAghUU4IQGX9BfWG5flxAyf7nVNwvGGGOM/bwizbuWaQRwABg6vWAu27nXRxHUGfWIaYI6oUSMCpSMesWoQUmoJsYECqJUGDPIiVJjXCAjyoRxg5QoMyYEaqBcmDBIQLkxKaAKtUYwjDHGPh+AG7O7PA07TvBlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/@2x/ic_form_pulldown@2x.png
// module id = 925
// module chunks = 0